import { useContext } from 'react'

import { PageInfoContext } from '../context/PageInfoProvider'

export { usePageInfo }

const usePageInfo = () => {
  const context = useContext(PageInfoContext)

  /* v8 ignore next -- @preserve */
  if (!context) {
    throw Error(
      'This hook needs to be wrapped in a PageInfoProvider to function',
    )
  }

  return context
}
